import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';


//components import
import SignInPage from "./authentication/SignInPage";
import ForgetPassword from "./authentication/ForgetPassword";


class Landing extends React.Component {
    //
    constructor(props) {
        super(props);

        this.state = {
            user: null,
        }
    }

    renderSignIn() {

        return (
            <div>
                <Route exact path={"/"} component={SignInPage} />
                <Route exact path={"/forgot-password"} component={ForgetPassword} />
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.renderSignIn()}
            </div>
        );
    }

}

export default  withRouter(connect(null)(Landing));